import React from 'react';
import { Glyphicon } from 'react-bootstrap'
import InputBox from '../../components/InputBox'

class UrlBox extends React.Component {
	// Public
	setValue = (value) => { this._input.setValue(value); }
	getValue = () => { this._input.getValue(); }
	focus = () => { this._input.focus(); }
	select = () => { this._input.select(); }
	flag = (status) => { this._input.flag(status); }
	completed = () => { return this._input.completed(); }

	validate = () => {
		let errorMessage = 'Invalid Url.';
		let value = this._input.getValue();
		// eslint-disable-next-line
		var re = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;

		if (value === "" || value === null)
            return null;	
            
        if (this.props.onValidate)
			return this.props.onValidate(value);

		if (!re.test(String(value).toLowerCase()))
			return errorMessage;

		return null;
	}

	shouldComponentUpdate(nextProps) {
		return (
			nextProps.value !== this.props.value
			|| nextProps.placeholder !== this.props.placeholder
			|| nextProps.disabled !== this.props.disabled);
	}

	// React
	render() {
		const props = {
			...this.props
		}

		let url = this.props.value;
		if (this.props.value && this.props.isExternal && !url.startsWith("http://") && !url.startsWith("https://") && !url.startsWith("ftp://"))
			url = "http://" + url;

		return (
			<div className="input-group">
				<InputBox {...props} ref={(input) => this._input = input} />
				<div className="input-group-addon">
					{this.props.clickable ?
						<a target={ this.props.targetBlank ? "_blank" : ""} href={url} >
							<Glyphicon style={{ color:"#555" }} glyph="globe" />
						</a>
					:
						<Glyphicon style={{ color:"#555" }} glyph="globe" />
					}
				</div>
			</div>)
	}
}

export default UrlBox;

// Mark this as a form component
UrlBox.defaultProps = {
	formControl: true,
	managed: false,
	maxLength: 64,
	targetBlank: true,
	isExternal: true,
	clickable: true
};



// WEBPACK FOOTER //
// ./src/fw/forms/controls/urlBox/UrlBox.js